//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TableLogDetail',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};